export const Images = {
  // Root assets
  adaptiveIcon: new URL("../adaptive-icon.png", import.meta.url).href,
  andyHdLogo: new URL("../andyhdlogo.png", import.meta.url).href,
  andyIcon: new URL("../AndyIcon.png", import.meta.url).href,
  favicon: new URL("../favicon.png", import.meta.url).href,
  icon: new URL("../icon.png", import.meta.url).href,
  splashRoot: new URL("../splash.png", import.meta.url).href,

  // Images folder
  logo: new URL("./carousal1.png", import.meta.url).href,
  splashBg: new URL("./carousal2.png", import.meta.url).href,
  news: new URL("./news.png", import.meta.url).href,
  referalLanding: new URL("./referal_landing.png", import.meta.url).href,
  splash: new URL("./Splashscreen.png", import.meta.url).href,

  // Icons folder
  andyAndroidIcon: new URL("../icons/andy-android-icon.png", import.meta.url).href,
  andyIconAlt: new URL("../icons/andy-icon.png", import.meta.url).href,
  andyPointingSplash: new URL("../icons/andy-pointing-splash.png", import.meta.url).href,
  andyicon: new URL("../icons/andyicon.png", import.meta.url).href,
  crimeLocation: new URL("../icons/crimelocation.png", import.meta.url).href,
  crimeLocation1: new URL("../icons/crimelocation1.png", import.meta.url).href,
  h: new URL("../icons/h.png", import.meta.url).href,
  home: new URL("../icons/home.png", import.meta.url).href,
  iosDark: new URL("../icons/ios-dark.png", import.meta.url).href,
  iosLight: new URL("../icons/ios-light.png", import.meta.url).href,
  iosTinted: new URL("../icons/ios-tinted.png", import.meta.url).href,
  offenderLocation: new URL("../icons/offenderlocation.png", import.meta.url).href,
  r: new URL("../icons/r.png", import.meta.url).href,
  splashIconDark: new URL("../icons/splash-icon-dark.png", import.meta.url).href,
  splashIconLight: new URL("../icons/splash-icon-light.png", import.meta.url).href,
  y: new URL("../icons/y.png", import.meta.url).href,

  // UserAssets/images folder
  addButton: new URL("../UserAssets/images/add-button.png", import.meta.url).href,
  andyKnowsPowerPicFile: new URL(
    "../UserAssets/images/ANDY_KNOWS_POWER_PicFile.jpg",
    import.meta.url
  ).href,
  andyWithALightbulb: new URL("../UserAssets/images/ANDY_WITH_A_LIGHTBULB.jpg", import.meta.url)
    .href,
  andyHoldingPresent: new URL("../UserAssets/images/andy-holding-present.png", import.meta.url)
    .href,
  andyHoldingSign: new URL("../UserAssets/images/andy-holding-sign.jpg", import.meta.url).href,
  andyNoText: new URL("../UserAssets/images/andy-no-text.png", import.meta.url).href,
  andyPointing: new URL("../UserAssets/images/andy-pointing.png", import.meta.url).href,
  andyPowerBanner: new URL("../UserAssets/images/andy-power-banner.png", import.meta.url).href,
  andyRefund: new URL("../UserAssets/images/andy-refund.png", import.meta.url).href,
  andyText: new URL("../UserAssets/images/andy-text.png", import.meta.url).href,
  andyCheck: new URL("../UserAssets/images/andyCheck.png", import.meta.url).href,
  andyHdLogoUserAssets: new URL("../UserAssets/images/andyhdlogo.png", import.meta.url).href,
  andyHeader: new URL("../UserAssets/images/AndyHeader.png", import.meta.url).href,
  appleLogo: new URL("../UserAssets/images/apple-logo.png", import.meta.url).href,
  arrowIcon: new URL("../UserAssets/images/ArrowIcon.png", import.meta.url).href,
  bgPattern: new URL("../UserAssets/images/bg-pattern.png", import.meta.url).href,
  charts: new URL("../UserAssets/images/Charts.png", import.meta.url).href,
  chatButton: new URL("../UserAssets/images/chatButton.png", import.meta.url).href,
  darkGreenButton: new URL("../UserAssets/images/DarkGreenButton.png", import.meta.url).href,
  form1: new URL("../UserAssets/images/form1.png", import.meta.url).href,
  googleLogo: new URL("../UserAssets/images/google.png", import.meta.url).href,
  homeButton: new URL("../UserAssets/images/home-button.png", import.meta.url).href,
  knowsPower: new URL("../UserAssets/images/knows-power.png", import.meta.url).href,
  pin: new URL("../UserAssets/images/pin.png", import.meta.url).href,
  twitter: new URL("../UserAssets/images/twitter.png", import.meta.url).href,
  noPropertyHome: new URL("../UserAssets/images/home.png", import.meta.url).href,
  propertyHomeMarker: new URL("../UserAssets/images/homemarker.png", import.meta.url).href,
  taxBillIcon: new URL("../UserAssets/images/tax.png", import.meta.url).href,
  savingsIcon: new URL("../UserAssets/images/savings.png", import.meta.url).href,
  communityIcon: new URL("../UserAssets/images/community.png", import.meta.url).href,
} as const;
